export const PROCESS_TEMPLATE_NAME_MAX_LENGTH = 255;
export const PROCESS_EXECUTE_INTERVAL_UNITS = ['day', 'week', 'month', 'year', 'byCoreTask'];
export const PROCESS_INTERVAL_ANCHORS = ['accept', 'deadline'];
